export const getNavConstants = (
  hasViewAllRequestsPermissions: boolean,
  hasCreateRequestPermissions: boolean,
  openChangeRequests: boolean
) => {
  const baseConstants = [
    {
      routes: ["/", "/projects"],
      title: openChangeRequests ? "New connection" : "Requests",
    },
    ...(openChangeRequests
      ? [
          {
            routes: ["/changes"],
            title: "Change & remove",
          },
        ]
      : []),
  ];

  //origin_user, origin_admin
  if (hasViewAllRequestsPermissions && hasCreateRequestPermissions) {
    return [...baseConstants, { routes: ["/reports"], title: "Reports" }];
  }
  //origin_limited
  if (hasViewAllRequestsPermissions) {
    return [...baseConstants];
  }
  //user
  return [
    ...baseConstants,
    { routes: ["/drafts"], title: "Drafts" },
    { routes: ["/tasks"], title: "Tasks" },
  ];
};
